import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import compose from 'recompose/compose'
import Phaser from 'components/Phaser'

const styles = (theme) => ({
  section: {
    minHeight: 100,
    marginBottom: 45,
  },
  header: {
    display: 'block',
  },
  subheader: {
    color: theme.palette.secondary.main,
    fontWeight: 500,
    fontStyle: 'italic',
  },
})

const SidebarSection = ({ classes, theme, render, header, subheader }) => (
  <div className={classes.section}>
    <div className={classes.header}>
      <Phaser color={theme.palette.primary.main} label={header} />
      {subheader && (
        <Typography
          className={classes.subheader}
          variant="caption"
          gutterBottom
        >
          {subheader}
        </Typography>
      )}
    </div>
    {render()}
  </div>
)

SidebarSection.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  render: PropTypes.func.isRequired,
  header: PropTypes.string,
}

// prettier-ignore
export default compose(
  withStyles(styles, { withTheme: true }),
)(SidebarSection)



// WEBPACK FOOTER //
// ./src/components/Sidebar/Section.js